import axios from 'axios';

/**
 * Cliente axios del módulo Soporte. Mismo patrón que sepeformacion/inventario:
 * baseURL = REACT_APP_API_URL + /api/soporte, interceptor que añade el Bearer
 * desde localStorage. Solo funciones nombradas (no default export).
 */
const API = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api/soporte`,
});

API.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// — Categorías / áreas de incidencia
export const listAreasActivas = () => API.get('/categorias').then((r) => r.data);
export const listAreasAdmin = () => API.get('/admin/categorias').then((r) => r.data);
export const crearArea = (data) => API.post('/admin/categorias', data).then((r) => r.data);
export const editarArea = (id, data) => API.put(`/admin/categorias/${id}`, data).then((r) => r.data);
export const moverArea = (id, direccion) =>
  API.patch(`/admin/categorias/${id}/orden`, { direccion }).then((r) => r.data);
export const cambiarActivaArea = (id, activa) =>
  API.patch(`/admin/categorias/${id}/activa`, { activa }).then((r) => r.data);

// — Búsqueda de personas (crear "en nombre de", solo técnicos)
export const buscarPersonas = (q) => API.get('/personas/buscar', { params: { q } }).then((r) => r.data);

// — Tickets (lado usuario)
export const listMisTickets = (tab) => API.get('/tickets/mios', { params: { tab } }).then((r) => r.data);
export const getTicket = (id) => API.get(`/tickets/${id}`).then((r) => r.data);
// payload puede ser objeto plano (JSON) o FormData (multipart con imágenes):
// axios fija el Content-Type adecuado automáticamente en cada caso.
export const crearTicket = (payload) => API.post('/tickets', payload).then((r) => r.data);

export const crearComentario = (ticketId, contenido) =>
  API.post(`/tickets/${ticketId}/comentarios`, { contenido }).then((r) => r.data);

export const eliminarAdjunto = (ticketId, adjuntoId) =>
  API.delete(`/tickets/${ticketId}/adjuntos/${adjuntoId}`).then((r) => r.data);

// — Panel admin
export const listPanelTickets = (params) => API.get('/panel/tickets', { params }).then((r) => r.data);
export const getPanelKpis = () => API.get('/panel/kpis').then((r) => r.data);
export const getPanelEquipo = () => API.get('/panel/equipo').then((r) => r.data);
export const getPanelTicket = (id) => API.get(`/panel/tickets/${id}`).then((r) => r.data);
export const patchPanelTicket = (id, payload) => API.patch(`/panel/tickets/${id}`, payload).then((r) => r.data);
export const crearComentarioPanel = (ticketId, payload) =>
  API.post(`/panel/tickets/${ticketId}/comentarios`, payload).then((r) => r.data);

// Exporta a XLSX los tickets que cumplen los filtros actuales (mismos params que
// listPanelTickets, sin page/pageSize). Devuelve la respuesta completa (blob)
// para que el caller pueda leer el header Content-Disposition si lo necesita.
// En error 400 (demasiados_resultados) axios rechaza; el blob de error se parsea fuera.
export const exportarPanelTickets = (params) =>
  API.get('/panel/tickets/exportar', { params, responseType: 'blob' });
